import { getErrorMessage } from "../getErrorMessage";
import type { Validator } from "./types";

export const list: Validator = ({
  name,
  answer,
  validation,
  questionErrorMessage,
}) => {
  const allowedValues = validation.value as string[];
  const valid = allowedValues.includes(answer);

  return {
    id: name,
    valid,
    message: valid
      ? undefined
      : getErrorMessage({
          validationMessage: validation.message,
          questionErrorMessage,
        }),
  };
};
